// import { appController } from "@app/model/mc/app/AppController";
import { appController } from "@app/model";
import { Dispatcher, fileMapUtils, indexedDbUtils, listenDocumentActive, teamGroupMap } from "@fanfanlo";
import { env } from "@src/confs/env";
import {matrixInit, matrixModel} from "@im/matrix";
import getConfig from "next/config";
import { mainModel } from "./MainModel";


import filesMap from "../../../confs/filesMap.json"

export class MainController extends Dispatcher{
    

    /**
     * 加载对应的配置文件并存入 mainModel.appConfig
     */
    async loadAppConfigFile() {
        const conf = getConfig();
        const { env, region } = conf?.publicRuntimeConfig || {};
        const date = new Date();
        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const hour = `0${date.getHours()}`.slice(-2);
        const minute = `0${date.getMinutes()}`.slice(-2);
        // const configUrl = `/config/main.${env}.${region}.json?v=${year}-${month}-${day}-${hour}-${minute}`;
        const configUrl = fileMapUtils.getFile(`/config/main.${env}.${region}.json`);
        // console.log('cofnig url=', configUrl)
        const res = await fetch(configUrl);
        if (!res.ok) throw new Error(`加载配置失败: ${configUrl}`);
        mainModel.appConfig = await res.json();
        matrixModel.matrixConf = mainModel.appConfig.matrix;
        // console.log('homepage mainModel.appConfig', mainModel.appConfig);
    }

    async init(){
        fileMapUtils.map = filesMap;
        await this.loadAppConfigFile();
        const conf = getConfig();
        await this.start();
    }
    async start(){
        teamGroupMap.def.gateway = env.gateway;
        listenDocumentActive();
        matrixInit.init();
        await indexedDbUtils.init()
        await appController.init()
        
    }
}

export const mainController = new MainController()